$(document).ready(function () {
  var navigation = $('nav.slde_show_nav');
  var contentSections = $('.content-section');

  // Show/hide navigation based on scroll position
  $(window).on('scroll', function () {
    var scrollTop = $(this).scrollTop();
    var lastSectionBottom = contentSections.last().offset().top + contentSections.last().height();

    if (scrollTop > 100 && scrollTop < lastSectionBottom - $(window).height()) {
      navigation.addClass('visible');
    } else {
      navigation.removeClass('visible');
    }
  });

  // Smooth scrolling for navigation links
  navigation.on('click', 'a', function (event) {
    event.preventDefault(); // Prevent default link behavior
    smoothScroll($(this.hash));
  });

  // Function for smooth scrolling
  function smoothScroll(target) {
    $('body,html').animate(
      {
        scrollTop: target.offset().top,
      },
      100
    );
  }
});

$(document).ready(function(){
  $('.brand-page-open').click(function(){
     $('.scroll-animation-section nav.slde_show_nav').toggleClass('active_bar');
  });

  // $('.scroll-animation-section nav.slde_show_nav ul').click(function(){
  //    var container = $(".slde_show_nav.visible.active_bar ul");
  //     // if the target of the click isn't the container nor a descendant of the container
  //     if (!container.is(e.target) && container.has(e.target).length === 0) 
  //     {
  //       container.removeClass('active_bar');
  //     }
  // });
  
});